import { useHubble } from '@seek/hubble';
import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import type AppState from 'src/types/appState';

export const useHubbleTrackEventHandler = () => {
  const { draftId, flowType, pageId, productSetId } = useSelector(
    (state: AppState) => ({
      draftId: state.session.draftId,
      flowType: state.tealium.cajaFlowType,
      pageId: state.session.pageId,
      productSetId: state.session.productSet?.id,
    }),
    shallowEqual,
  );

  const hubble = useHubble();

  const hubbleTrackEventHandler = useCallback(
    (eventName: any, eventData: any) => {
      hubble.trackEvent(eventName, {
        ...eventData,
        draftId,
        postingFlowType: flowType,
        postingFlowPageName: pageId,
        productSetId,
      });
    },
    [hubble, draftId, flowType, pageId, productSetId],
  );

  const getHubbleTrackEventHandler = () =>
    draftId && flowType && pageId && productSetId
      ? hubbleTrackEventHandler
      : () => {};

  return { getHubbleTrackEventHandler };
};
